/**
 * Chip — a small labelled count or tag.
 *
 * Distinct from Pill, which is a *status*: a chip carries a quantity or a name
 * ("+50 XP", "Strategy", "3 KP") and reads at sentence weight, where a pill is
 * an uppercase state marker. The student area had them as `.chip` with three
 * accent modifiers.
 */

import type { HTMLAttributes, ReactNode } from 'react';
import styles from './chip.module.css';

type ChipTone = 'neutral' | 'xp' | 'kp' | 'skill';

interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone;
  className?: string;
  children?: ReactNode;
}

export function Chip({ tone = 'neutral', className, children, ...rest }: ChipProps) {
  return (
    <span className={[styles.base, styles[tone], className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </span>
  );
}
